export default __webpack_public_path__ + "static/media/Cross.aaa2ef37.svg";